import { ADD_QUICK_LINK, DELETE_QUICK_LINK, EDIT_QUICK_LINK } from "../actionTypes"
import { addQuickLink, deleteQuickLink, editQuickLink } from "../../../api/home/quickLink.service"

const request = () => ({ type: ADD_QUICK_LINK.REQUEST })
const failure = (error) => ({ type: ADD_QUICK_LINK.FAILURE, error })
const success = () => ({ type: ADD_QUICK_LINK.SUCCESS })

export const AddQuickLink = (payload) => {
  return (dispatch, getState) => {
    dispatch(request());
    return addQuickLink(payload)
      .then((res) => {
        dispatch(success(res));
        return Promise.resolve({res:res,status:true});
      })
      .catch((error) => {
        dispatch(failure(error?.message));
        return Promise.resolve({error:error?.message,status:false});
      })
  }
}

const editRequest = () => ({ type: EDIT_QUICK_LINK.REQUEST })
const editFailure = (error) => ({ type: EDIT_QUICK_LINK.FAILURE, error })
const EditSuccess = () => ({ type: EDIT_QUICK_LINK.SUCCESS })

export const EditQuickLink = (payload,id) => {
  console.log("id",id)
  return (dispatch, getState) => {
    dispatch(editRequest());
    return editQuickLink(payload,id)
      .then((res) => {
        dispatch(EditSuccess(res));
        return Promise.resolve({res:res,status:true});
      })
      .catch((error) => {
        dispatch(editFailure(error?.message));
        return Promise.resolve({error:error?.message,status:false});
      })
  }
}

const deleteRequest = () => ({ type: DELETE_QUICK_LINK.REQUEST })
const deleteFailure = (error) => ({ type: DELETE_QUICK_LINK.FAILURE, error })
const deleteSuccess = () => ({ type: DELETE_QUICK_LINK.SUCCESS })

export const DeleteQuickLink = (id) => {
  return (dispatch, getState) => {
    dispatch(deleteRequest());
    return deleteQuickLink(id)
      .then((res) => {
        dispatch(deleteSuccess(res));
        return Promise.resolve({res:res,status:true});
      })
      .catch((error) => {
        dispatch(deleteFailure(error?.message));
        return Promise.resolve({error:error?.message,status:false});
      })
  }
}